module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	fox.registerWidget('Promo_Tutorial', {
		tutorialGallery: null,
		switchByHash: false,
		swipeGalleryApplied: false,
		
		configure: function () {

			this.registerOptions('', {
				autoRender: true,
				template: 'div.tutorial-page.layout-width',
				widgets: {
					started: {
						widget: 'Widget',
						template: 'promo_tutorial_start',
						container: '.tutorial-page',
						autoRender: true,
						group: 'tutorial',
						'handleDom.nextPage': {
							target: '.start',
							event: 'click',
							callback: '@parent:switchPage'
						}
					},
					slider: {
						widget: 'Widget',
						template: 'promo_tutorial',
						container: '.tutorial-page',
						autoRender: true,
						active: false,
						group: 'tutorial',
						'handleWom.sliderInit': {
							widget: '@this',
							event: 'addedToDom',
							callback: '@parent:initSlider'
						}
					}

				},
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.callParent('running', arguments);
			this.sliderPage = this.wom1('#slider');
		},

		switchPage: function() {
			this.switchEmbeddedWidget('slider');
		},

		initSlider: function (argument) {
			$('.slider').slick({
				centerMode: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				adaptiveHeight: true,
				speed: 500,
				fade: true,
				responsive: [
					{
						breakpoint: 320,
						settings: {
							arrows: false,
							dots: true,
							dotsClass: 'slick-dots',
							centerMode: false
						}
					},
					{
						breakpoint: 768,
						settings: {
							dots: false,
							arrows: true
						}
					}
				]
			});

			$('.slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
				$(this).parent().find('.slider-txt .item').each(function(i, elt){
					$(elt).removeClass('active');
				});
				$(this).parent().find('[data-slide='+ currentSlide +']').addClass('active');
			});
		}


	});
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/tutorial.js
// module id = 671
// module chunks = 2